// extracted by mini-css-extract-plugin
export var brand = "_8p-9";
export var compact = "_8p-6";
export var extraSmall = "_8p-7";
export var icon = "_8p-0";
export var large = "_8p-4";
export var light = "_8p-1";
export var medium = "_8p-5";
export var outline = "_8p-b";
export var primaryDark = "_8p-a";
export var primaryLight = "_8p-8";
export var primaryModern = "_8p-c";
export var success = "_8p-2";
export var successSolid = "_8p-3";